var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { SYNC_PRODUCTS_REQUEST, syncStoreProductFailure, syncStoreProductSuccess, } from '../../actions';
import APIIN from '@/utils/APIIN';
const onSyncStoreProduct = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        console.log(action.payload.channelId);
        try {
            APIIN.post(`/sync/api/shopify/product/sync`, {
                "channelId": action.payload.channelId,
            })
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* syncStoreProductWorker(action) {
    try {
        const data = yield call(onSyncStoreProduct, action);
        yield put(syncStoreProductSuccess(data));
    }
    catch (error) {
        yield put(syncStoreProductFailure(error));
    }
}
export function* watchStoreSyncProductsData() {
    yield takeLatest(SYNC_PRODUCTS_REQUEST, syncStoreProductWorker);
}
